export default "__VITE_ASSET__BTxBYakE__"